export default "__VITE_ASSET__DXMAdrWy__"